module.exports = __webpack_public_path__ + "static/img/Home63@2x.816c0c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home63@2x.png
// module id = nxt2
// module chunks = 1